import { render, staticRenderFns } from "./area-chart.vue?vue&type=template&id=5d622189&scoped=true"
import script from "./area-chart.vue?vue&type=script&lang=js"
export * from "./area-chart.vue?vue&type=script&lang=js"
import style0 from "./area-chart.vue?vue&type=style&index=0&id=5d622189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d622189",
  null
  
)

export default component.exports